module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/8746be77d55517644e5df63cc465cc15.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/view-icon.svg
// module id = gQpM
// module chunks = 1